import { render, staticRenderFns } from "./PaymentContainerPsf.vue?vue&type=template&id=1a655208"
import script from "./PaymentContainerPsf.vue?vue&type=script&lang=js"
export * from "./PaymentContainerPsf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports